import { required } from 'vuelidate/lib/validators'

export default function documentValidations() {
    return {
        document: {
            productionDepartmentId: {
                required: required
            },
            typeId: {
                required: required
            },
            proposedDate: {
                required: required
            }
        }
    }
}
